import { QSortV2Params } from '../../../parameters/types'
import { Assignation } from '../../../context/types'
import { DeckSizeType } from './constants'
import { ComponentPropsWithRef } from 'react'
import { WarningMessage } from '../components/warningMessage'
import { YesNoModalProps } from '../components/YesNoModal'
import { TranslatorFn } from '../../../i18n/useTranslation'

export const ItemTypes = {
    RankingStm: 'RankingStm',
}

export type AppStatus =
    | 'S1_42'
    | 'S2_11_LOW'
    | 'S3_11_HIGH'
    | 'S3_20_MID'
    | 'S4_20_MID'
    | 'S4_11_HIGH'
    | 'FINAL_OVERVIEW'
    | 'DONE_SENDING'

export type BinCounter = {
    max: number
    ref: string
    stms: Assignation[]
}

export type BinRefs =
    | 'to_assign'
    | 'least_important'
    | 'moderately_important'
    | 'most_important'

export type Bins = Record<BinRefs, BinCounter>
export type BinAssignFn = (
    stmRef: string, // was stmValueKey
    destBinRef: BinRefs,
    srcBinRef?: BinRefs,
    lvl?: number
) => void
export type StepDistribution = [number, number, number]
export const phase2index = {
    p42: 0, // FIXME unused
    p11low: 1,
    p11high: 2,
    p20mid: 3,
} as const
export type QRankedStms = [Bins | null, Bins | null, Bins | null, Bins | null]
export type AppState = {
    status: AppStatus
    // Params
    nBucket: 7 | 9
    nStm: DeckSizeType
    hasMidBucketRanking?: boolean
    // Init
    stms2rank: Assignation[]
    // Dynamic
    rankedStms: QRankedStms //
    rankingIsReflected: boolean // TODO API
    finalBuckets: Assignation[][]
    //
    initBinsStore: (
        t: TranslatorFn,
        q2Params: QSortV2Params,
        langIndex: number,
        shuffled?: boolean
    ) => void
    onClickToNext: (t: TranslatorFn) => void
    setHasMidBucketRanking: (enabled: boolean) => void
    setRankingIsReflected: (isReflected: boolean) => void
    markAs: (status: AppStatus) => void
    onMoveStmDistro: (stmId: string, from: string, to: string, destinationIndex?: number) => void
    prepareBuckets: () => void
    selectedBucket: number | null
    setSelectedBucket: (bucket: number | null) => void
    onHoverBin: (binRef: BinRefs, isIn: boolean) => void
    highlightedBars?: number[]
}

export type BinState = {
    bins: Bins
    selectedBinRef: BinRefs | null
    assignBin: BinAssignFn
    selectBin: (bin: BinRefs) => void
    assignAllRnd: () => void
}

export type PaginatedState = {
    page: number
    maxPerPage: number
    setPage: (page: number) => void
    setMaxPerPage: (maxPerPage: number) => void
}

export type UIState = {
    warningProps: Partial<ComponentPropsWithRef<typeof WarningMessage>> | null
    yesNoModalProps: YesNoModalProps | null
    hasNextBtn: boolean
    title: string
    histogramCount: number[]
    updateWarningProps: (
        props: Partial<ComponentPropsWithRef<typeof WarningMessage>> | null
    ) => void
    closeYesNoModal: () => void
    setHasNextBtn: (hasNextBtn: boolean) => void
    setFinalBucketsRnd: () => void
}

export type BinsStore = AppState &
    QSortV2Params &
    BinState &
    PaginatedState &
    UIState
